import { getSubscriptionDownsell } from '@services/api/downsell'
import { formatDateShort } from '@utils/dateFormatter'
import { formatMoney } from '@utils/moneyFormatter'
import { useQuery } from 'react-query'

export interface IFormattedDownsell {
  id: number
  offerTitle: string
  currentAmount: string
  newAmount: string
  newPriceCents: number
  // Percentual de desconto (0-100, arredondado) — badge "-X%" e título do modal.
  discountPercent: number
  period: string | null
  startsAt: string | null
}

// Pré-carregada (enabled = flag + assinatura cancelável) para o modal abrir
// instantâneo no clique de cancelar. Inelegível/erro => null — o fluxo de
// cancelamento NUNCA pode ser bloqueado por esta query (fail-open).
export function useSubscriptionDownsellQuery(
  orderId: number | string,
  enabled: boolean,
) {
  return useQuery(
    ['orders', String(orderId), 'downsell'],
    async (): Promise<IFormattedDownsell | null> => {
      const { data } = await getSubscriptionDownsell(orderId)

      if (!data?.eligible || !data.downsell) return null

      const { current_price_cents: currentCents, new_price_cents: newCents } =
        data.downsell

      return {
        id: data.downsell.id,
        offerTitle: data.downsell.offer?.title ?? '',
        currentAmount: formatMoney(currentCents),
        newAmount: formatMoney(newCents),
        newPriceCents: newCents,
        discountPercent:
          currentCents > 0
            ? Math.round((1 - newCents / currentCents) * 100)
            : 0,
        period: data.downsell.offer?.period ?? null,
        startsAt: data.downsell.next_invoice_at
          ? formatDateShort(data.downsell.next_invoice_at)
          : null,
      }
    },
    { enabled, retry: 1, staleTime: 60_000 },
  )
}
